import { useMutation } from "@apollo/client";

import { VerifyPhoneNumberMutation, VerifyPhoneNumberMutationVariables } from "@ctypes";
import { USER, VERIFY_PHONE_NUMBER } from "@graphql";

export const useVerifyPhoneNumber = (variables?: VerifyPhoneNumberMutationVariables) => {
  return useMutation<VerifyPhoneNumberMutation, VerifyPhoneNumberMutationVariables>(
    VERIFY_PHONE_NUMBER,
    {
      variables,
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
